import { Dropdown, Space } from 'antd';
import Iconfont from "@/components/Icon/IconFont";
import { changeLanguage, getCurrentLanguage } from "@/utils/lang";
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const LangSelect = () => {

    const dispatch = useDispatch();

    // 语言选项
    const langOptions = [
        { key: 'zh', label: '中文' },
        { key: 'en', label: 'English' },
        { key: 'id', label: 'Bahasa Indonesia' },
        { key: 'jp', label: '日本語' }
    ];

    // 语言切换处理函数
    const [currentLangLabel, setCurrentLangLabel] = useState(() => {
        // 从保存的语言初始化
        return getCurrentLanguage() || 'zh';
    });

    // 组件挂载时更新语言
    useEffect(() => {
        const savedLang = getCurrentLanguage();
        if (savedLang) {
            setCurrentLangLabel(getLangLabel(savedLang));
        }
    }, []);

    const getLangLabel = (key) => {
        return langOptions.find(item => item.key === key).label || key
    };

    const handleLanguageChange = (item) => {
        const key = item.key;
        changeLanguage(key);
        dispatch({ type: "setLanguage", data: key })
        setCurrentLangLabel(getLangLabel(key));
    };

    return (
        <div >
            <Dropdown menu={{ items: langOptions, onClick: handleLanguageChange }} trigger={["click"]} >
                <a onClick={e => e.preventDefault()}>
                    <Space>
                        <Iconfont icon="faLanguage" />
                        <span >{currentLangLabel}</span>
                    </Space>
                </a>
            </Dropdown>
        </div>
    );
};

export default LangSelect;